export default class ResourceRepository {
  constructor({ resourceService }) {
    this.resourceService = resourceService;
  }

  getResourceInfo(uuid, token = null, hideContext = false) {
    return this.resourceService.getResourceInfo(uuid, token, hideContext);
  }
}
